import CalendarAccordion from './CalendarAccordion'

export default CalendarAccordion
